import { instance } from '@/libs/api/instance'

export const getList = ({ walletId, status, type, page, sort }) => {
  return instance.get('/v2/card', {
    params: {
      walletId,
      status,
      page,
      sort,
      type,
    },
  })
}
